"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialCard = void 0;
var _litHtml = require("lit-html");
require("./styles/SocialCard.css");
const SocialCard = SocialData => {
  const {
    accounts
  } = SocialData;
  if (accounts.length) {
    return (0, _litHtml.html)`
      <section
        class="socialCard"
        aria-labelledby="social-card-title"
        data-testid="social-media"
      >
        <nav aria-label="Social media profiles">
          <ul class="socialList list-reset" role="list">
            ${accounts.map(account => renderAccount(account))}
          </ul>
        </nav>
      </section>
    `;
  }
  function renderAccount(account) {
    return account.homepage && account.name && account.icon ? (0, _litHtml.html)`
          <li class="socialItem" role="listitem">
            <a 
              href="${account.homepage}" 
              target="_blank" 
              rel="noopener noreferrer" 
              aria-label="Visit ${account.name} profile (opens in new tab)"
            >
              <img 
                class="socialIcon" 
                src="${account.icon}" 
                alt="${account.name} icon"
                width="40"
                height="40"
                loading="lazy"
              />
              <span class="text-wrap-anywhere">${account.name}</span>
            </a>
          </li>
        ` : (0, _litHtml.html)``;
  }
};
exports.SocialCard = SocialCard;